import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Chat from './pages/Chat';
import ImageGen from './pages/ImageGen';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingScreen from './components/LoadingScreen';
import ToastContainer from './components/ToastContainer';

const App: React.FC = () => {
  const initializeAuth = useAuthStore((s) => s.initializeAuth);
  const loading = useAuthStore((s) => s.loading);
  const user = useAuthStore((s) => s.user);

  const initRef = useRef(false);

  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;
    const unsubscribe = initializeAuth();
    return () => {
      unsubscribe();
      initRef.current = false;
    };
  }, [initializeAuth]);

  if (loading) {
    return (
      <>
        <LoadingScreen />
        <ToastContainer />
      </>
    );
  }

  return (
    <>
      <Router>
        <Routes>
          {/* Auth routes */}
          <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
          <Route path="/register" element={user ? <Navigate to="/" replace /> : <Register />} />
          <Route path="/forgot-password" element={user ? <Navigate to="/" replace /> : <ForgotPassword />} />

          {/* Chat routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat/:chatId"
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            }
          />

          {/* Image Gen */}
          <Route
            path="/image-gen"
            element={
              <ProtectedRoute>
                <ImageGen />
              </ProtectedRoute>
            }
          />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default App;